import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"


const PurposeOfInformation = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>4. Purpose of Information Usage</Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>All collected data is used strictly for operational purposes including:
        <List>
            <ListItem>
                <ListItemText>
                    • Employee check-in/check-out and attendance tracking
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                   • Assigning and validating customer visits

                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    • Creating and processing sales orders and payments
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    • Calculating outstanding balances and generating receipts
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    • Analyzing sales performance through real-time reports
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    • Managing inventory, pricing, and UOM calculations
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    • Enhancing service delivery and internal analytics
                </ListItemText>
            </ListItem>
        </List>
       We do not use any data for advertising, external marketing, or third-party 
analytics.
        </Typography>
        <Divider sx={{ my: 2 }}/>
    </>
  )
}

export default PurposeOfInformation